module.exports = __webpack_public_path__ + "static/media/CesarMarquesHover.66b32a56.png";